/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AccountingData', 'model/ImportAccountingActualsFileRequest', 'model/AccountingDataPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/AccountingData'), require('../model/ImportAccountingActualsFileRequest'), require('../model/AccountingDataPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.AccountingDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.AccountingData, root.ForStractionServiceApi.ImportAccountingActualsFileRequest, root.ForStractionServiceApi.AccountingDataPaginationSlice);
  }
}(this, function(ApiClient, AccountingData, ImportAccountingActualsFileRequest, AccountingDataPaginationSlice) {
  'use strict';

  /**
   * AccountingData service.
   * @module api/AccountingDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new AccountingDataApi. 
   * @alias module:api/AccountingDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the accountingDataAddAllPut operation.
     * @callback module:api/AccountingDataApi~accountingDataAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/AccountingData>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.batchSize  (default to 0)
     * @param {module:api/AccountingDataApi~accountingDataAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.accountingDataAddAllPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountingDataAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchSize': opts['batchSize']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/AccountingData/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataCalculateFinancialDataGet operation.
     * @callback module:api/AccountingDataApi~accountingDataCalculateFinancialDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * calculateFinancialData
     * @param {String} _4SAPIAppID 
     * @param {Date} startDate 
     * @param {module:api/AccountingDataApi~accountingDataCalculateFinancialDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountingDataCalculateFinancialDataGet = function(_4SAPIAppID, startDate, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataCalculateFinancialDataGet";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling accountingDataCalculateFinancialDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': startDate
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/AccountingData/calculateFinancialData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataDeleteAllPut operation.
     * @callback module:api/AccountingDataApi~accountingDataDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/AccountingDataApi~accountingDataDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountingDataDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountingDataDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/AccountingData/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataEditAllPut operation.
     * @callback module:api/AccountingDataApi~accountingDataEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/AccountingData>} body 
     * @param {module:api/AccountingDataApi~accountingDataEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountingDataEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountingDataEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/AccountingData/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataGetDimensionPreviewGet operation.
     * @callback module:api/AccountingDataApi~accountingDataGetDimensionPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getDimensionPreview
     * @param {String} _4SAPIAppID 
     * @param {Integer} dimensionNumber 
     * @param {module:api/AccountingDataApi~accountingDataGetDimensionPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'String'>}
     */
    this.accountingDataGetDimensionPreviewGet = function(_4SAPIAppID, dimensionNumber, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataGetDimensionPreviewGet";
      }

      // verify the required parameter 'dimensionNumber' is set
      if (dimensionNumber == undefined || dimensionNumber == null) {
        throw "Missing the required parameter 'dimensionNumber' when calling accountingDataGetDimensionPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'dimensionNumber': dimensionNumber
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/AccountingData/getDimensionPreview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataGetIntegrationStatusGet operation.
     * @callback module:api/AccountingDataApi~accountingDataGetIntegrationStatusGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getIntegrationStatus
     * @param {String} _4SAPIAppID 
     * @param {module:api/AccountingDataApi~accountingDataGetIntegrationStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.accountingDataGetIntegrationStatusGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataGetIntegrationStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/AccountingData/getIntegrationStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataGetUsedAccountsFromAccountRangeGet operation.
     * @callback module:api/AccountingDataApi~accountingDataGetUsedAccountsFromAccountRangeGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getUsedAccountsFromAccountRange
     * @param {String} _4SAPIAppID 
     * @param {Integer} indicatorId 
     * @param {module:api/AccountingDataApi~accountingDataGetUsedAccountsFromAccountRangeGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.accountingDataGetUsedAccountsFromAccountRangeGet = function(_4SAPIAppID, indicatorId, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataGetUsedAccountsFromAccountRangeGet";
      }

      // verify the required parameter 'indicatorId' is set
      if (indicatorId == undefined || indicatorId == null) {
        throw "Missing the required parameter 'indicatorId' when calling accountingDataGetUsedAccountsFromAccountRangeGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'indicatorId': indicatorId
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/AccountingData/getUsedAccountsFromAccountRange', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataLoadAllManualAccountsGet operation.
     * @callback module:api/AccountingDataApi~accountingDataLoadAllManualAccountsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AccountingData>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAllManualAccounts
     * @param {String} _4SAPIAppID 
     * @param {module:api/AccountingDataApi~accountingDataLoadAllManualAccountsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AccountingData>}
     */
    this.accountingDataLoadAllManualAccountsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataLoadAllManualAccountsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [AccountingData];

      return this.apiClient.callApi(
        '/AccountingData/loadAllManualAccounts', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataParseAccountingFilePut operation.
     * @callback module:api/AccountingDataApi~accountingDataParseAccountingFilePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * parseAccountingFile
     * @param {String} _4SAPIAppID 
     * @param {module:model/ImportAccountingActualsFileRequest} body 
     * @param {module:api/AccountingDataApi~accountingDataParseAccountingFilePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountingDataParseAccountingFilePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataParseAccountingFilePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountingDataParseAccountingFilePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/AccountingData/parseAccountingFile', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountingDataSearchSlicePut operation.
     * @callback module:api/AccountingDataApi~accountingDataSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountingDataPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/AccountingData} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {module:api/AccountingDataApi~accountingDataSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountingDataPaginationSlice}
     */
    this.accountingDataSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling accountingDataSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountingDataSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'order': opts['order']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = AccountingDataPaginationSlice;

      return this.apiClient.callApi(
        '/AccountingData/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
